<!--
마감완료 기능 - 완료처리
------------------------------------

-->
<template>
    <!-- 모달 -->
    <div id="modal-done" class="uk-modal-full" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
            <div uk-grid class="uk-grid-small uk-padding" uk-height-viewport>

                
                <div class="uk-card uk-card-default uk-card-body uk-card-small uk-width-1-4@l">
                    <!-- 대기화면 -->
                    <div v-show="jobState === 'ready'">
                        <p class="uk-text-center uk-text-large">
                            <i class="material-icons uk-text-middle" style="font-size: 120px">assignment_turned_in</i><br />
                            Set box to complete the closing<br />
                            선택한 배송(BOX)를 [마감완료] 합니다
                        </p>         

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large2"
                                type="button"
                                v-on:click="jobStart()"
                            >
                                <span uk-icon="icon: play; ratio: 2"></span>
                                START (작업시작)
                            </button>
                        </div>               
                    </div>

                   
                    <!-- 실행중 -->
                    <div v-show="jobState === 'doing'">
                        <p class="uk-text-center uk-text-danger uk-text-large">
                            "작업이 진행중입니다. 작업이 종료될때까지 브라우저를 닫지마세요"
                        </p>
                    </div>
                    
                    <!-- 완료 (성공) -->
                    <div v-show="jobState === 'done' && failCount === 0">
                        <p class="uk-text-center uk-text-large uk-text-primary">
                            <i class="material-icons uk-text-middle" style="font-size: 120px">done</i><br />
                            Task is done!
                        </p> 
                        <p class="uk-text-center  uk-text-large">
                            마감작업이 완료되었습니다.<br />
                            출고작업을 진행하세요
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large2"
                                type="button"
                                title="출고작업 페이지로 이동"
                                @click="moveShipoutPage"
                            >
                                <i class="material-icons uk-text-middle" style="font-size: 40px">forward</i>
                                GO TO SHIP-OUT
                            </button>
                        </div>
                    </div>
                    
                    <!-- 완료 (실패) -->
                    <div v-show="jobState === 'done' && failCount > 0">
                        <p class="uk-text-center uk-text-large uk-text-danger">
                            <i class="material-icons uk-text-middle" style="font-size: 120px">warning</i><br />
                            Some task have failed!
                        </p> 
                        <p class="uk-text-center  uk-text-large">
                            실패한 작업이 있습니다.<br />
                            발송할 수 없는 BOX는 [출고보류] 하세요
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large2"
                                type="button"
                                title="현재페이지 새로고침"
                                @click="refreshPage"
                            >
                                <i class="material-icons uk-text-middle" style="font-size: 40px">refresh</i>
                                REFRESH PAGE
                            </button>
                        </div>
                    </div>

                    

                </div>

                
        
                <div class="uk-width-3-4@l uk-margin-top">
                    <!-- 진행률 -->
                    <div class="uk-text-large uk-text-primary uk-margin-left">
                        {{ successCount }} / {{ targetCount }}
                        <span v-show="failCount > 0" class="uk-text-danger">(실패 : {{ failCount }})</span>
                    </div>
                    <progress id="js-progressbar" class="uk-progress uk-margin-remove" :value="successCount" :max="targetCount" ></progress>
                    
                    

                    <!-- 작업 리스트 -->
                    <table class="uk-table uk-table-divider">
                    <thead>
                        <tr>
                            <th class="uk-text-center">진행상태</th>

                            <th class="uk-text-center">배송코드</th>
                            <th class="uk-text-center">배송단계</th>
                            <th class="uk-text-center">수취인</th>

                            <th class="uk-text-center">BLNO</th>
                            <th class="uk-text-center">HAWB</th>
                            <th class="uk-text-center">패키지 수</th>
                            <th class="uk-text-center">회원사서함</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(target, index) in jobTargets"
                            :key="index"
                        >
                            <td class="uk-text-center">
                                <div v-show="target.state === 'ready'" class="uk-text-muted">
                                    대기
                                </div>
                                <div v-show="target.state === 'doing'" class="uk-text-primary">
                                    <span uk-icon="icon: play"></span>
                                    처리중..
                                </div>
                                <div v-show="target.state === 'success'" class="uk-text-success">
                                    <span uk-icon="icon: check"></span>
                                    성공
                                </div>
                                <div v-show="target.state === 'fail'" class="uk-text-danger">
                                    <span uk-icon="icon: close"></span>
                                    실패
                                </div>

                                <!-- 작업메세지 -->
                                <div v-show="target.job_msg" class="uk-text-meta">
                                    {{ target.job_msg }}
                                </div>
                            </td>

                            <td class="uk-text-center">
                                {{ target.item.code }}

                                <!-- 상세링크 -->
                                <a
                                    class="uk-link"
                                    onclick="$.app.on_event.move(arguments);"
                                    :data-url="'/prods/'+target.item.first_prod_id"
                                    data-target="_blank"
                                    uk-tooltip="상품상세"
                                ><span uk-icon="link"></span></a>
                            </td>
                            <td class="uk-text-center">
                                {{ target.item.state_text }}
                            </td>
                            <td class="uk-text-center">
                                {{ target.item.name }}
                            </td>


                            <td class="uk-text-center">
                                {{ target.item.blno }}
                            </td>
                            <td class="uk-text-center">
                                {{ target.item.hawb }}
                            </td>
                            <td class="uk-text-center">
                                {{ target.item.package_amount }}
                            </td>
                            <td class="uk-text-center">
                                {{ target.item.user_mailbox }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
        },
        data: function () {
            
            return {
                /**
                 * 현재 작업진행상태 
                 *  - none : 작업 초기화되지 않은상태 (모달창 뜨지 않음)
                 *  - ready : 작업 대기중
                 *  - doing : 진행중
                 *  - done : 완료
                 */
                jobState: 'ready',

                /**
                 * 작업대상 (작업상태 와 실제 작업대상이되는 아이템정보를 가진다.)
                 *  - 작업이 초기화될때, 작성된다.
                 * [
                 *  {state: 'success', job_msg: '작업관련 메세지(성공/실패)', item: {실제아이템정보}, next: {다음아이템포인터}},
                 *  {state: 'fail', ...},
                 *  {state: 'doing', ...},
                 *  {state: 'ready', ...},
                 * ]
                 */
                jobTargets: [],
            };
        },
        computed: {

            // 작업대상 전체 카운트
            targetCount() {
                return this.jobTargets.length;
            },

            // 작업성공 카운트
            successCount() {
                return _.filter(this.jobTargets, ['state', 'success']).length;
            },

            // 작업실패 카운트
            failCount() {
                return _.filter(this.jobTargets, ['state', 'fail']).length;
            },
        },
        methods: {
            // 작업초기화 (모달창이 띄워지는 순간 초기화작업)
            jobInit() {
                // 진행상태
                this.jobState='ready';

                // 작업대상아이템 배열작성
                let targets = _.map(this.batch.checked_items, item => {
                    return {
                        state: 'ready',
                        job_msg: null,
                        item: item
                    };
                });

                // 작업대상 아이템에 next 연결
                for (let i=0; i < targets.length; i++) {
                    let curr = targets[i];
                    let next = targets[i+1];
                    curr.next = next ? next : null; // 다음아이템없으면 널
                }
                this.jobTargets = targets;
                //console.log(this.jobTargets);

                // 모달창
                UIkit.modal($('#modal-done')).show();
            },

            // 작업시작
            jobStart() {

                // 컨펌
                if (! confirm(this.targetCount+' 개  배송(BOX)이 출고마감으로 변경됩니다. 정말 실행합니까?')) {
                    return;
                }

                // 진행상태
                this.jobState='doing';

                // 첫번째 작업대상의 작업실행
                this.workOneTarget(this.jobTargets[0]);
            },

            // 작업완료
            jobDone() {
                // 진행상태
                this.jobState='done';
            },

            // 현재페이지 갱신
            refreshPage() {
                $.app.refresh();
            },

            // 출고페이지로 이동
            moveShipoutPage() {
                $.app.move('/regions/'+this.regionId+'/shipout-job');
            },

            /**
             * 하나의 작업대상에 대한 작업을 실행
             * @param target 작업대상 (jobTargets 배열의 아이템)
             */
            workOneTarget(target) {
                // 클로저 위해서 정의
                let cmp = this;


                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/houses/'+target.item.id+'/to-end',
                    data: {
                        '_token': cmp.csrfToken,
                    },
                    success: function (response, textStatus, jqXHR) {
                        // 성공으로 설정
                        target.state = 'success';
                        target.job_msg = response.msg;
                        target.item.state_text = response.state_text;
                    },
                    alert_error_msg: function(msg){
                        // 실패로 설정
                        target.state = 'fail';
                        target.job_msg = msg;                        
                    },
                    complete: function(jqXHR, textStatus){
                        // 다음타겟 호출
                        if (target.next) {
                            cmp.workOneTarget(target.next);
                        } else {
                            // 다음없으면, 전체작업 완료처리
                            cmp.jobDone();
                        }  

                    }
                };
                // ajax 실행
                $.app.ajax.module.default(opts);
                
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>